import { requestGet, requestPost } from '@/common/request';

export const businessGroundList = async (query) => requestGet('/businessGround/list', query);
export const getMarketActivityDetail = async (query) => requestGet('/businessGround/getMarketActivityDetail', query);
export const businessGroundCreate = async (data) => requestPost('/businessGround/createConfig', data);
export const updateConfig = async (data) => requestPost('/businessGround/updateConfig', data);
export const getSubActivityDetail = async (query) => requestGet('/businessGround/getSubActivityDetail', query);
export const getConfigDetail = async (query) => requestGet('/businessGround/getConfigDetail', query);
export const delConfig = async (query) => requestGet('/businessGround/deleteConfig', query);
